export default __webpack_public_path__ + "static/media/latest-news-header-img-04.ece0687c.jpg";